import { Helpers } from '../../helpers';
import { IDirectionalServiceCompany } from '../../interfaces/idirectional-service-company';
import { DirectionalCost } from '../directional-cost';
import { Rig } from '../rig';

export class DirectionalServiceCompanyBase {
  DirectionalServiceCompanyId: number;
  Description: string;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  DirectionalCosts_DirectionalServiceCompany?: Array<DirectionalCost> | null;
  Rigs_DirectionalServiceCompany?: Array<Rig> | null;

  constructor(item?: IDirectionalServiceCompany) {
    if (item) {

      this.DirectionalServiceCompanyId = item.DirectionalServiceCompanyId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.DirectionalCosts_DirectionalServiceCompany = Helpers.createClassArray(DirectionalCost, item.DirectionalCosts_DirectionalServiceCompany);
      this.Rigs_DirectionalServiceCompany = Helpers.createClassArray(Rig, item.Rigs_DirectionalServiceCompany);
    }
  }
}